import axios from '@/libs/axios'

const list = (_, queryParams) => axios.get('/exam-result-innovation/', { params: queryParams })

const excel = (_, queryParams) => axios.get('/statistics/apply_docs_exams', { params: queryParams })

export default {
  list,
  excel,
}
